<template>
    <div>
        <v-file-input
                v-model="icon"
                label="عکس"
                outlined
                :multiple="limit>1"
                @change="submitFiles"
                accept="image/png, image/jpeg, image/bmp"
                placeholder="عکس موردنظر خود را باگذاری کنید."
                hint="حداکثر حجم هر عکس مورد نظر می‌تواند 2مگابابت باشد."
                prepend-inner-icon="mdi-camera"
                clearable
                small-chips
                clear-icon="mdi-close-circle-outline"
                prepend-icon=""
                :loading="progressPercent !== '' "
                dense
                class="mt-1"
        ></v-file-input>

    </div>
</template>

<script>
import {Axios2, Bus} from "../../../main";

export default {
    name: "imageUploader",
    props: {
        limit: {default: 1},
    },
    data() {
        return {
            progressPercent: '',
            icon: [],
        }
    },
    methods: {
        submitFiles() {
            if (this.icon.length > this.limit)
                this.$modal.error('خطا!', 'تعداد عکس مجاز برای آپلود 10 می باشد.');

            if (this.icon.length <= 0)
                return;

            let formData = new FormData();

            if (this.limit > 1)
                this.icon.forEach(img => {
                    formData.append('image[]', img);
                });
            else
                formData.append('image[]', this.icon);

            Axios2.post('/upload/image', formData, {
                onUploadProgress: (response) => {
                    const {loaded, total} = response;
                    let percent = Math.floor((loaded * 100) / total)
                    this.progressPercent = `${loaded}kb of ${total}kb | ${percent}%`;

                },
            }).then((x) => {
                this.$modal.success('موفق!', x.data.message);
                this.progressPercent = '';
                Bus.$emit('getImage', x.data.data);

            }).catch((error) => {
                this.$modal.error('خطا!', error.response.data.errors.image[0])
                this.progressPercent = '';
            });
        },
    },
}
</script>

<style scoped>

</style>